import { get, find } from "lodash";
/**
 * helper method to return googleSheetId
 * @param {Array<Object>} resources
 * @returns string | undefined
 */
export function extractGoogleSheetId(survey) {
  const googleSheetId = get(
    find(get(survey, "resources", []), { name: "source" }),
    "value",
    ""
  );
  return googleSheetId;
}

/**
 * Helper method to return the appropriete setter function
 * such function defined and returned from the React 
 * useState hook.
 * @param {String | null} err 
 * @param {String | null} success 
 * @param {function} errfn 
 * @param {function} successfn 
 * @returns 
 */
export function messagefnSwitcher(err, success, errfn, successfn) {
  if (err) {
    return errfn;
  } else if (success) {
    return successfn;
  }
}

/**
 * Helper method used to return the variant(color) in which the 
 * snackbar component will render the message.
 * @param {string} errMsg 
 * @returns 
 */
export function messageSwitcher(errMsg) {
  if (errMsg) {
    return "warning";
  }
  return "info";
}
